import { Theme } from '@lumx/react';

export const calculateThemeColor = (theme: string = Theme.light) => {
    return theme !== Theme.light ? 'light' : 'dark';
};
